import React, { useState } from "react";

const SuggestButton = ({ postId, postTitle }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [userId, setUserId] = useState("");
  const [profileId, setProfileId] = useState("");

  // Handle the suggestion action
  const handleSuggest = () => {
    if (!userId) {
      alert("Please enter a User ID to suggest the post.");
      return;
    }

    console.log(`Suggesting post "${postTitle}" (ID: ${postId}) to User ID: ${userId}, Profile ID: ${profileId || "default users"}`);
    
    // Close popup after submission
    setShowPopup(false);
    
    // You can replace this with an actual API call, e.g.:
    // fetch("/api/suggest", { method: "POST", body: JSON.stringify({ postId, userId, profileId }) });
  };

  return (
    <div>
      {/* Suggest span acting as a button */}
      <span 
        onClick={() => setShowPopup(true)}
        style={{ cursor: "pointer", color: "darkgray", fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif", fontSize: 18 }}
      >
        📌 Suggest
      </span>

      {/* Popup Container */}
      {showPopup && (
        <div style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "white",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          zIndex: 1000,
          background: "black",
          color: "darkgray"
        }}>
          <h3>Suggest Post</h3>
          <input
            type="text"
            placeholder="Enter User ID"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            style={{ padding: "5px", marginBottom: "10px", display: "block" }}
            color="darkgray"
          />
          <input
            type="text"
            placeholder="Enter Profile ID (Optional)"
            value={profileId}
            onChange={(e) => setProfileId(e.target.value)}
            style={{ padding: "5px", marginBottom: "10px", display: "block" }}
          />
          <button onClick={handleSuggest} style={{ marginRight: "10px", cursor: "pointer" }}>
            Confirm
          </button>
          <button onClick={() => setShowPopup(false)} style={{ cursor: "pointer" }}>
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default SuggestButton;
